<template>
  <div>
    <button type="button" class="btn btn-primary btn-with-addon" @click="showModal">
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Issue Book(s)
    </button>

    <a-modal v-model="visible" title="Issue Book(s)" :width="this.settings['isMobileView'] ? 480 : 1080">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit1" type="primary" htmlType="submit" :loading="loading" @click="savedata(false)">Issue</a-button>
        <!-- <a-button key="submit2" type="primary" htmlType="submit" :loading="loading" @click="savedata(true)">Submit & Generate Bill</a-button> -->
      </template>

      <a-form class="mb-4" :form="form">
        <div class="row align-items-center mb-2">
          <div class="col-6 mb-2">
            <a-form-item label="Select Student" class="mb-2">
              <a-select
                show-search
                size="default"
                v-decorator="['student_id',{
                  rules: [{
                    required: true,
                    message: 'Please select a student',
                  }],
                }]"
                placeholder="Search student.."
                optionFilterProp="children"
                style="width: 100%"
                @search="searchStudents"
                :filterOption="true"
                :defaultValue="undefined"
              >
                <a-select-option :value="0">
                  All Students
                </a-select-option>
                <template>
                  <a-select-option v-for="student in students" :value="student.id" :key="student.id">
                    {{student.first_name + ' ' + student.last_name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-3 mb-2">
            <a-form-item label="Date">
              <a-date-picker style="width: 100%"
                             v-decorator="['loan_date', { rules: [{ required: false, message: 'Please input date' }], initialValue: moment() },]"
                             :format=dateFormat />
            </a-form-item>
          </div>
          <!-- <div class="col-3 mb-2">
            <a-form-item label="Paid by">
              <a-input
                placeholder="Paid by"
                v-decorator="['paid_by',{rules: [{ max: 30, message: 'Must not exceed 30 characters!' },],},]"
              />
            </a-form-item>
          </div> -->
        </div>
        <div class="row align-items-center mb-2">
          <!-- <p v-if="selectedStudent && selectedStudent.length > 0">
            <span class="pr-2">Student ID:</span> <span class="font-weight-bold px-2">{{selectedStudent.enrollment[0].student.student_code }}</span>|
            <span class="px-2">Class:</span> <span class="font-weight-bold px-2">{{selectedStudent.enrollment[0].school_classes.name}}</span>|
            <span class="px-2">Section:</span> <span class="font-weight-bold px-2">{{selectedStudent.enrollment[0].section.name}}</span>|
            <span class="px-2">Roll No:</span> <span class="font-weight-bold px-2">{{selectedStudent.enrollment[0].roll_no}}</span>
          </p> -->
        </div>
        <a-form-item label="Remark">
          <a-input placeholder="Remark" v-decorator="['remark',]" />
        </a-form-item>

        <div class="mt-3">
          <p class="text-uppercase font-weight-bold text-muted">
            Books
          </p>

          <div class="row mb-4">
            <div id='items-header' class="row text-center font-weight-bold" style="width: 100%">
              <div class="col-4 mr-2">Title</div>
              <div class="col">Code</div>
              <div class="col">Author</div>
              <div class="col">Avl. Copies</div>
              <div class="col">Expected Return Date</div>
            </div>
            <div class="col-12" v-for="(key, index) in productGroupings" :key="key">
              <div class="d-flex">
                <div class="mr-2 pt-2">
                  <span class="font-weight-bold">{{ index + 1 }}.</span>
                </div>
                <div class="col-4">
                  <a-form-item>
                    <a-select
                      show-search
                      style="width: 100%"
                              v-decorator="[
                      `product_group[${key - 1}]`,
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select a Book!',
                          },
                          {
                            validator: checkIfProductAlreadyAdded,
                          }
                        ],
                        initialValue: undefined,
                      },
                    ]"
                              placeholder="Search Book..."
                              optionFilterProp="children"
                              @search="searchProducts"
                              @change="handleChangeProduct($event, key)"
                              :filterOption="true"
                              :defaultValue="undefined"
                    >
                      <a-select-option v-for="product in products" :key="product.id">
                        {{ product.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
                <div class="col">
                  <a-form-item>
                  <a-input-number
                    style="width: 100%"
                    placeholder="Avl. Qnt. Hidden"
                    v-decorator="[`avl_qnt_hidden[${key - 1}]`, {rules: [{ required: false, message: 'Please input avl qnt.!' }], initialValue: 0}]"
                    :disabled="true"
                    :style="{ display: 'none' }"
                  />
                  </a-form-item>
                  <a-form-item>
                    <a-input
                      style="width: 100%"
                      placeholder="Avl. Qnt."
                      v-decorator="[`code[${key - 1}]`, {rules: [{ required: false, message: 'Please input avl qnt.!' },{ validator: checkQuantity }], initialValue: 0}]"
                      :disabled="true"
                    />
                  </a-form-item>
                </div>
                <div class="col">
                  <a-form-item>
                    <a-input
                      style="width: 100%"
                      placeholder="Rate"
                      v-decorator="[`author[${key - 1}]`, {rules: [{ required: false, message: 'Please input rate!' }], initialValue: 0}]"
                      :disabled="true"
                      :min="0"
                    />
                  </a-form-item>
                </div>
                <div class="col">
                  <a-form-item>
                    <a-input-number
                      style="width: 100%"
                      placeholder="Add Qnt." :disabled="true"
                      v-decorator="[`avl_qty[${key - 1}]`, {rules: [{ required: true, message: 'Please input quantity!' }], initialValue: 0},]"
                      @change="handleQuantityChange($event,key)"
                      :min="0"
                    />
                  </a-form-item>
                </div>
                <div class="col">
                  <a-form-item>
                    <a-date-picker style="width: 100%"
                             v-decorator="[`expected_return_date[${key - 1}]`, { rules: [{ required: false, message: 'Please input date' }], initialValue: moment().add(10, 'days') },]"
                             :format=dateFormat />
                  </a-form-item>
                </div>

                <div class="ml-2 pt-1">
                  <button class="btn btn-sm btn-danger" @click.prevent="handleRemoveProductGrouping(key)">
                    <i class="btn-addon-icon fe fe-trash-2" />
                  </button>
                </div>
              </div>
            </div>
            <!-- <div id='items-footer' class="row text-center font-weight-bold" style="width: 100%">
              <div class="col-4 mr-2"></div>
              <div class="col"></div>
              <div class="col"></div>
              <div class="col">Total(Rs):</div>
              <div class="col">
                <a-form-item>
                  <a-input-number
                    style="width: 100%"
                    placeholder="Total"
                    v-decorator="[`final_total_amount`, {rules: [{ required: false, message: 'Please input quantity!' }], initialValue: 0}]"
                    :disabled="true"
                    :min="0"
                  />
                </a-form-item>
              </div>
              <div class="ml-2 pt-1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            </div> -->
            <div class="col-12">
              <div class="add-button">
                <button class="add-prod" @click.prevent="handleAddProductGrouping">
                  + Add book
                </button>
              </div>
            </div>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
// import { fetchInventoryData } from '@/components/inventory/common'
import { downloadBill } from '../common'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'IssueBook',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      categories: [],
      productGroupings: [],
      productCounter: 0,
      productGroups: [],
      prodGroupSpinning: false,
      selectedIssuedToStudent: null,
      students: [],
      studentSearch: null,
      products: [],
      productSearch: null,
      dateFormat: 'DD-MM-YYYY',
      quantityValidationStatus: '',
      quantityValidationMessage: '',
      previousQuantityValue: 0,
    }
  },
  mounted: function () {
    /* let d = fetchInventoryData('category')
    d.then((data) => {
      this.categories = data.data
    }).catch((err) => console.error(err)) */

    // this.getProducts()
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  watch: {
    formVisible: function (n, o) {
      // console.log('formvisible changed??', n)
      this.visible = n
    },
  },
  methods: {
    moment,
    getProducts: function () {
      this.$http
        .get('/api/library/books', { /// api/inventory/product/stock/all
          params: {
            limit: 10,
            search: this.productSearch,
            page: 1,
          },
        })
        .then(({ data }) => {
          this.products = data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleAddProductGrouping() {
      this.productCounter++
      if (this.productGroupings.length < 10) {
        this.productGroupings.push(this.productCounter)
      }
      this.products = []
    },
    handleRemoveProductGrouping(key) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Click Ok to remove this book.`,
        onOk: () => {
          this.productGroupings = this.productGroupings.filter(
            (item) => item !== key
          )
          this.$nextTick(() => {
            this.setFinalTotalAmount()
          })

          // Todo: this below line is use to re-validate (i.e. to clear existing validation) but it is not working
          // this.form.validateFields([...this.form.getFieldValue(`product_group[0]`)], { force: true })
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
    showModal() {
      this.visible = true
    },
    savedata: function (shouldGenerateBill) {
      this.loading = true
      this.form.validateFields((err, values) => {
        console.log('savedata', values.product_group)
        if (!err) {
          // clearform(this.form)
          this.$confirm({
            title: `Are you sure you want to issue the book(s)?`,
            content: `Click on the OK button to issue the book(s)!`,
            onOk: () => {
              let orderItems = []
              for (let i = 0; i < values.product_group.length; i++) {
                if (!values.product_group[i]) { // Don't send if product id is empty. This occurs for deleted product line item.
                  continue
                }
                let orderItem = {
                  'book_id': values.product_group[i],
                  'expected_return_date': values.expected_return_date[i].format('YYYY-MM-DD HH:mm:ss'),
                  // 'price': 0, // Price will calculated in the backend
                }
                orderItems.push(orderItem)
              }

              this.$http
                .post('/api/library/book/loans', { /// api/inventory/order/new
                  student_id: values.student_id,
                  loan_date: values.loan_date.format('YYYY-MM-DD HH:mm:ss'),
                  // paid_by: values.paid_by == null ? '' : values.paid_by,
                  remark: values.remark == null ? '' : values.remark,
                  order_items: orderItems,
                })
                .then((resp) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  if (resp.status === 200 || resp.status === 201) {
                    this.$notification['success']({
                      message: 'Book(s) issued successfully',
                      description: `Book(s) issued successfully`,
                    })
                  } else {
                    this.$notification['warning']({
                      message: 'Unknown Error',
                      description: `There appears to be an error while submitting data. Response from server: ${resp.status} ${resp.message}`,
                      duration: 0,
                    })
                  }
                  this.form.resetFields()
                  console.log('resp.data:::', resp.data)
                  const order = resp.data.data
                  if (shouldGenerateBill) {
                    this.generateBill(order)
                  }
                })
                .catch((err) => {
                  this.loading = false
                  this.$neoNotify.error(err)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    generateBill(order) {
      downloadBill(this.$http, order.id, order.student.student_code, order.order_no)
    },
    handleCancel(e) {
      this.visible = false
    },
    handleChangeIssuedToStudent: function (value) {
      if (value) {
        this.selectedIssuedToStudent = value
      }
    },
    getStudents: function(isSearch) {
      this.staffSpinning = true

      /* let page = this.staffCurrent
      if (isSearch) {
        page = 1
        this.staffCurrent = 1
      } */
      this.$http.get('/api/student', {
        params: {
          limit: 10,
          search: this.studentSearch,
          page: 1,
        },
      }).then(({ data }) => {
        this.students = data.data
        console.log('student: ', this.students)
      })
    },
    searchStudents: function(value) {
      if (value) {
        this.studentSearch = value
        this.getStudents(true)
      }
    },
    handleChangeProduct: function (productId, rowKey) {
      const selectedProducts = this.form.getFieldValue(`product_group`)
      if (selectedProducts.includes(productId)) {
        alert('Duplicate product entry!')
        const fieldData1 = {}
        fieldData1[`product_group[${rowKey - 1}]`] = undefined
        fieldData1[`avl_qnt_hidden[${rowKey - 1}]`] = 0
        fieldData1[`code[${rowKey - 1}]`] = 0
        fieldData1[`author[${rowKey - 1}]`] = 0
        fieldData1[`avl_qty[${rowKey - 1}]`] = 0
        this.form.setFieldsValue(fieldData1)
        // this.form.validateFields(['product_group'], { force: true })
        this.form.validateFields(['avl_qnt'], { force: true })
        return false
      }
      let selectedProduct = this.products.filter((product) => {
        return product.id === productId
      })[0]
      // const quantity = this.form.getFieldValue(`quantity[${rowKey - 1}]`)
      const fieldData = {}
      fieldData[`avl_qnt_hidden[${rowKey - 1}]`] = selectedProduct.balance_quantity
      fieldData[`code[${rowKey - 1}]`] = selectedProduct.code
      fieldData[`author[${rowKey - 1}]`] = selectedProduct.author
      fieldData[`avl_qty[${rowKey - 1}]`] = selectedProduct.balance_quantity
      this.form.setFieldsValue(fieldData)
    },
    searchProducts: function(value) {
      if (value) {
        this.productSearch = value
        this.getProducts(true)
      }
    },
    handleQuantityChange: function (quantityValue, rowKey) {
      const updatedFields = {}
      const unitPrice = this.form.getFieldValue(`unit_price[${rowKey - 1}]`)
      const originalAvlQuantity = this.form.getFieldValue(`avl_qnt_hidden[${rowKey - 1}]`)
      const totalAmount = unitPrice * quantityValue
      updatedFields[`total_amount[${rowKey - 1}]`] = totalAmount
      updatedFields[`avl_qnt[${rowKey - 1}]`] = originalAvlQuantity - quantityValue
      this.form.setFieldsValue(updatedFields)
      this.form.validateFields(['avl_qnt'], { force: true })
      this.previousQuantityValue = quantityValue
      this.setFinalTotalAmount()
    },
    setFinalTotalAmount() {
      let subTotals = this.form.getFieldValue(`total_amount`)
      // subTotals = subTotals.filter((item) => item !== undefined) // Reindexing
      console.log('subTotals')
      console.log(subTotals)
      let finalTotalAmount = 0
      for (let i = 0; i < subTotals.length; i++) {
        finalTotalAmount = finalTotalAmount + (subTotals[i] ? subTotals[i] : 0)
      }
      this.form.setFieldsValue({ 'final_total_amount': finalTotalAmount })
    },
    checkQuantity(rule, value, callback) {
      console.log('rule_value:: ', value)
      if (value < 0) {
        callback(new Error('Insufficient quantity'))
      } else {
        callback()
      }
    },
    checkIfProductAlreadyAdded(rule, productId, callback) {
      const selectedProducts = this.form.getFieldValue(`product_group`)
      const count = selectedProducts.filter(selectedProductId => selectedProductId === productId).length
      if (count > 1) {
        console.log('Inside Check')
        callback(new Error('Product already added!'))
      } else {
        callback()
      }
    },
  },
}
</script>

<style>
.add-button {
  display:flex;
  justify-content: center;
}
.add-prod {
  background: none;
  border: 1px dashed grey;
  width: 20rem;
  margin-top: 5px;
}
.add-prod:focus {
  outline: none;
}
</style>
